<div class="actions">
    <p-breadcrumb class="max-w-full" [model]="breadcrumbItems" [home]="home"/>

    <constructor-add-element-drawer/>

    <p-button class="cancel"
              label="Отменить"
              severity="secondary"
              size="small"
              (click)="dropChanges()"/>
    @if (widget().id) {
        <p-button class="save"
                  label="Изменить"
                  size="small"
                  (click)="updateExistingWidget()"/>
    } @else {
        <p-button class="edit"
                  label="Добавить"
                  size="small"
                  (click)="createNewWidget()"/>
    }
</div>

<div class="constructor">
    <p-splitter styleClass="splitter" [panelSizes]="[75, 25]" [minSizes]="[30, 25]">
        <ng-template #panel>
            <p-splitter layout="vertical" [panelSizes]="[80, 20]" [minSizes]="[30, 20]">
                <ng-template #panel>
                    <widget-constructor/>
                </ng-template>
                <ng-template #panel>
                    <constructor-node-select/>
                </ng-template>
            </p-splitter>
        </ng-template>
        <ng-template #panel>
            <constructor-settings/>
        </ng-template>
    </p-splitter>
</div>
